import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/del-rio")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Del Rio, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades, boat covers and aluminum fabrication for Del Rio & Val Verde County.",
      keywords: "pergola covers Del Rio, pergola covers Texas, custom pergola covers Del Rio, aluminum pergola covers Del Rio",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Del Rio, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Del Rio and Val Verde County.",
    }),
    scripts: cityHeadScripts("Del Rio", "Val Verde County"),
  }),
  component: () => <CityHomePage city="Del Rio" region="Val Verde County" />,
});
